import { selectAtom } from "jotai/utils";
import type { IHeaderV2Store } from "../components/HeaderV2/stores/header-v2-store";
import { HeaderV2Store } from "../components/HeaderV2/stores/header-v2-store";
import type { IHeaderV2LayoutStoreBackButton } from "../components/HeaderV2/stores/header-v2-layout-store";

function selector(index: IHeaderV2Store): IHeaderV2LayoutStoreBackButton | undefined {
  return index.layoutStore?.backButton;
}

export const BackButtonStore = selectAtom(HeaderV2Store, selector);
